export default {
  text: 'black',
  primary: '#bf1d2c',
  secondary: '#2b2b2b',
  background: 'white',
  backgroundSecondary: '#000000',
  light: '#FFF',
  dark: '#020303'
}
